// Where the rest of the service lives. The marketing site links to all three
// and belongs to none of them, so every name is configured rather than guessed
// - see .env.production for the deployed values.
export const ADMIN_URL = (import.meta.env.VITE_ADMIN_URL || 'http://localhost:3001').replace(/\/$/, '');
export const SIGNAGE_URL = (import.meta.env.VITE_SIGNAGE_URL || 'http://localhost:3000').replace(/\/$/, '');

// The shelf the page shows off. It is a real share token for a real account,
// which is the point - a mock-up would not prove that the link works.
const DEMO_SHARE_CODE = import.meta.env.VITE_DEMO_SHARE_CODE || '';

export const DEMO_SHELF_URL = DEMO_SHARE_CODE
  ? `${SIGNAGE_URL}/?code=${encodeURIComponent(DEMO_SHARE_CODE)}`
  : '';
